import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import config from "../../config";
import { formatApiError } from "../../utilities/apiErrorMessages";

export const LogOutHand = createAsyncThunk("logout/LogOutHand", async (token, { dispatch }) => {
    dispatch(unauthentication())

    if (token) {
        fetch(`${config.apiUrl}/logout`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        }).catch(() => {})
    }

    window.location.replace('/login')
    return null
})


export const LogoutSlice = createSlice({
    name: "logout",
    initialState: { user: null, error: null, loading: false },
    reducers: {
        unauthentication: () => {
            if (typeof window !== "undefined") {
                localStorage.removeItem("jwt");
                localStorage.removeItem("user");
            }
        },

    },
    extraReducers: {
        [LogOutHand.pending]: (state, action) => {
            state.loading = true

        },
        [LogOutHand.fulfilled]: (state, action) => {
            state.loading = false
            state.user = null



        },
        [LogOutHand.rejected]: (state, action) => {

            state.loading = false
            state.error = formatApiError(action.payload, 'Logout failed')

        },
    }
})

export default LogoutSlice.reducer;
export const { unauthentication } = LogoutSlice.actions